import { render, staticRenderFns } from "./OrganizationRolesTab.vue?vue&type=template&id=388068c7&scoped=true"
import script from "./OrganizationRolesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationRolesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationRolesTab.vue?vue&type=style&index=0&id=388068c7&prod&lang=css"
import style1 from "./OrganizationRolesTab.vue?vue&type=style&index=1&id=388068c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388068c7",
  null
  
)

export default component.exports